import { render, staticRenderFns } from "./SearchModalTexts.vue?vue&type=template&id=125ba094"
import script from "./SearchModalTexts.vue?vue&type=script&lang=js"
export * from "./SearchModalTexts.vue?vue&type=script&lang=js"
import style0 from "./SearchModalTexts.vue?vue&type=style&index=0&id=125ba094&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports